import { Link } from 'react-router-dom';
import { getLocaleContent } from '../content';
import { buildLocalizedPath } from '../routing';
import type { Locale } from '../types';
import { ServicePicture } from './services/ServicePicture';

interface ServicesPageProps {
  locale: Locale;
}

const PHOTOS = ['services_1', 'services_2', 'services_3', 'services_4', 'services_5'];

export function ServicesPage({ locale }: ServicesPageProps) {
  const content = getLocaleContent(locale);
  const section = content.services;
  const assist = content.assistAlt;
  const contactPath = buildLocalizedPath(locale, 'contact');

  return (
    <>
      <section className="services-header">
        <div className="ui-container services-header-inner">
          <span className="ui-eyebrow">{content.nav.services} / Empire Granit / Narva</span>
          <h1 className="ui-display ui-display-1 services-title">{section.title}</h1>
          <p className="services-lead">{section.lead}</p>
        </div>
      </section>

      <section className="services-blocks">
        <div className="ui-container">
          {section.items.map((item, idx) => {
            const reversed = idx % 2 === 1;
            const photo = PHOTOS[idx] ?? PHOTOS[0];
            const numeral = String(idx + 1).padStart(2, '0');
            return (
              <article
                key={item.title}
                className={`services-block${reversed ? ' services-block--reversed' : ''}`}
              >
                <div className="services-block__copy">
                  <span className="services-block__numeral">{numeral}.</span>
                  <h2 className="services-block__title">{item.title}</h2>
                  <p className="services-block__body">{item.body}</p>
                </div>
                <div className="services-block__photo">
                  <ServicePicture name={photo} alt={item.title} />
                </div>
              </article>
            );
          })}
        </div>
      </section>

      <section className="services-contact-band assist-band">
        <div className="ui-container services-contact-inner">
          <span className="ui-eyebrow">{assist.eyebrow}</span>
          <h2 className="assist-band__title">{assist.title}</h2>
          <p className="assist-band__body">{assist.body}</p>
          <Link className="services-contact-link" to={contactPath}>
            {assist.link}
          </Link>
        </div>
      </section>
    </>
  );
}
